<app-enfaf-modal
  [title]="title"
  svgIcon="modal-group"
  (onClose)="confirmCloseModal()"
  (onConfirm)="changeRole()"
  [isLoading]="isChangingRole"
  buttonConfirmText="Cambiar Rol"
  [disableConfirmButton]="changeForm.invalid || isChangingRole"
>
  <form class="container" [formGroup]="changeForm" autocomplete="off">
          <enfaf-select-light
        [options]="roleOptions"
        [control]="changeForm.controls.role"
        [placeholder]="'Selecciona nuevo rol'"
        [label]="'Selecciona nuevo rol'"
        >
      </enfaf-select-light>
  </form>
</app-enfaf-modal>


